// extracted by mini-css-extract-plugin
module.exports = {"contents":"Outter_contents__1RQLF"};